import React, { useEffect } from "react";
import { RouteProps, useNavigate, useParams } from "react-router-dom";

import ReturnSpecificCases from "../tools/RoutesTools";
import CpntPage from "../components/CpntPage";
import { IBreadCrumbs } from "../models/interfaces/IBreadCrumbs";
import { useKeycloak } from "@react-keycloak/web";
import { KeyCloakRoles } from "../config/helpers";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

type AdminPrivateRouteProps = RouteProps & {
  component: React.ComponentType<any>;
  ReturnPath?: string;
  ReturnPathAlt?: string;
  ReturnTitle?: string;
  ReturnClass?: string;
  BreadCrumbs?: IBreadCrumbs[];
  indexSEO?: boolean;
}

const AdminPrivateRoute: React.FC<AdminPrivateRouteProps> = ({
  component: Component,
  ReturnPath,
  ReturnPathAlt,
  ReturnTitle,
  ReturnClass,
  BreadCrumbs,
  indexSEO,
  ...rest
}) => {

  const { initialized:keycloakinitialized,keycloak } = useKeycloak();
  const navigate = useNavigate();
  const compte = useSelector((state: RootState) => state.compte);
  const params = useParams();
  useEffect(() => {
    if (keycloakinitialized) {
      if (!keycloak.authenticated || compte.Connected === false) {
        //AdminPrivateRoute : pas auth
        navigate("/admin/");
      } else if ((keycloak.authenticated && !keycloak?.hasRealmRole(KeyCloakRoles.ElectreBO.toString()))) {
        navigate("/accueil");
      } else {
        //AdminPrivateRoute : auth
      }
    }
  }, [keycloakinitialized,keycloak.authenticated,compte])
  
  return (
    <>
    <CpntPage
      ReturnPath={ReturnSpecificCases({ ReturnPath, ReturnPathAlt, params })}
      ReturnTitle={ReturnTitle}
      ReturnClass={ReturnClass}
      BreadCrumbs={BreadCrumbs}
      >
        <Component />
    </CpntPage>
    </>
  );
}

export default AdminPrivateRoute;